import CustomSlider from "./custom-slider";
import FloatToCursor from "./float-to-cursor";

class ProductsSlider {  

  private sliderTrack: HTMLElement | null = null;
  private customSlider: CustomSlider | null = null;

  private floatingContainerOne: HTMLElement | null = null;
  private floatingContainerTwo: HTMLElement | null = null;

  constructor() {
    this.sliderTrack = document.querySelector(".products-slider__track-el");
    if (!this.sliderTrack) return;
    this.customSlider = new CustomSlider(this.sliderTrack, {
      endless: true,
    });

    this.floatingContainerOne = document.querySelector(".products__floating-container--1");
    this.floatingContainerTwo = document.querySelector(".products__floating-container--2");

    if(this.floatingContainerOne) {
      new FloatToCursor(this.floatingContainerOne, {
        initialXPercent: 50,
        initialYPercent: 60,
        minYPercent: 0,
        maxYPercent: 100,
        minXPercent: 50,
        maxXPercent: 100,
        debounceTimeout: 100
      });
    }

    if(this.floatingContainerTwo) {
      new FloatToCursor(this.floatingContainerTwo, {
        initialXPercent: 70,
        initialYPercent: 30,
        minYPercent: 0,
        maxYPercent: 100,
        minXPercent: 50,
        maxXPercent: 100,
        debounceTimeout: 100
      });
    }
  }
}

export default function productsSlider() {
  return new ProductsSlider();
}